/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import * as R from 'ramda';
import { useQuery } from '@apollo/client';
import GetSimulationPricingsGroupHealthQuery from '../graphql/queries/GetSimulationPricingsGroupHealthQuery.js';

const useGetSimulationPricingsGroupHealthQuery = (args) => {
  const { data, error, loading, refetch } = useQuery(GetSimulationPricingsGroupHealthQuery, args);

  return {
    error,
    loading,
    refetch,
    getSimulationPricingsGroupHealth: R.omit(['__typename'], data?.getSimulationPricingsGroupHealth_simulation_pricings_group_health || {})
  };
};

export default useGetSimulationPricingsGroupHealthQuery;
